import { BadRequestResultModel, ErrorRequestResultModel, } from './self-serve-client';

export function isBadRequestResult(e: unknown): e is BadRequestResultModel {
	const badRequestResult = (e as BadRequestResultModel);
	return badRequestResult.status !== undefined && badRequestResult.status >= 400 && badRequestResult.status < 500;
}

export function isErrorRequestModel(e: unknown): e is ErrorRequestResultModel {
	const errorRequestModel = (e as ErrorRequestResultModel);
	return errorRequestModel.status !== undefined && errorRequestModel.status >= 500 && errorRequestModel.status < 600;
}
